import React, { useCallback, useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import { Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight, faArrowUpRightFromSquare, faEnvelope , faCheck, faChevronLeft, faChevronRight, faMagnifyingGlass, faPhone, faXmark } from '@fortawesome/free-solid-svg-icons';
import { Tab, Tabs } from 'react-bootstrap';
import { apiService } from '../../services/apiService';
import { toast } from 'react-toastify';
import { faCopy } from '@fortawesome/free-regular-svg-icons';

const SESSION_KEY = "myJobsPageState";

const saveStateToSession = (state) => {
  try {
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(state));
  } catch (err) {
    console.error("Failed to save state to sessionStorage:", err);
  }
};

const loadStateFromSession = () => {
  try {
    const data = sessionStorage.getItem(SESSION_KEY);
    return data ? JSON.parse(data) : {};
  } catch (err) {
    console.error("Failed to load state from sessionStorage:", err);
    return {};
  }
};
function MyJobs() {
    const navigate = useNavigate();
    const restored = loadStateFromSession();

    const [submitloader, setSubmitloader] = useState(false);
    const [applyId, setApplyId] = useState("");
    
    const [appliedJobslist, setAppliedJobs] = useState([]);
    const [paginatedata, setPaginateData] = useState({});
    const [activeTab, setActiveTab] = useState(restored.activeTab || "applied");
    const [currentPage, setCurrentPage] = useState(restored.currentPage || 1);
    const [searchQuery, setSearchQuery] = useState(restored.searchQuery || "");
    const [innerSearch, setInnersearch] = useState(restored.innerSearch || "");
    const [shorting, setShorting] = useState(restored.shorting || "");
    const [shorting2, setShorting2] = useState(restored.shorting2 || "");
    const [currentPage2, setCurrentPage2] = useState(restored.currentPage2 || 1);
    const [searchQuery2, setSearchQuery2] = useState(restored.searchQuery2 || "");
    const [innerSearch2, setInnersearch2] = useState(restored.innerSearch2 || "");
    const [pageSummary, setPagesummary] = useState("");
    const [loading, setLoading] = useState(true);


    const getCurrentState = useCallback(() => ({
        innerSearch, currentPage, searchQuery, shorting, shorting2, innerSearch2, currentPage2, searchQuery2, activeTab
    }), [
        innerSearch, currentPage, searchQuery, shorting, shorting2, innerSearch2, currentPage2, searchQuery2, activeTab
    ]);
    useEffect(() => {
        saveStateToSession(getCurrentState());
    }, [getCurrentState]);

    useEffect(() => {
        const handleBeforeUnload = () => {
            sessionStorage.removeItem("myJobsPageState");
        };

        window.addEventListener("beforeunload", handleBeforeUnload);

        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, []);

    const fetchAppliedJobs = useCallback(async (params = {}) => {
        
        try {
            const defaultParams = { sort: shorting, page: currentPage,search: innerSearch,...params };
            const queryString = new URLSearchParams(defaultParams).toString();
            const response = await apiService.getRequest(`/jobseeker/applied-jobs?${queryString}`);
            if (response && response.success === true) {
                setAppliedJobs(response.data);
                setPaginateData(response.meta);
                setPagesummary(response.pagination_summary);
            }else{
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error('Error fetching tab data:', error);
        } finally {
            setLoading(false);
        }
    }, [shorting,currentPage,innerSearch]);

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    };
    const handleSearch = () => {
        setCurrentPage(1);
        setInnersearch(searchQuery);
    };

    useEffect(() => {
        fetchAppliedJobs();
    }, [fetchAppliedJobs]);

    const [Jobslist, setJobs] = useState([]);
    const [paginatedata2, setPaginateData2] = useState({});
    const [pageSummary2, setPagesummary2] = useState("");
    const [loading2, setLoading2] = useState(true);

    const fetchSavedJobs = useCallback(async (params = {}) => {
        
        try {
            const defaultParams = { sort: shorting2, page: currentPage2, search: innerSearch2, ...params };
            const queryString = new URLSearchParams(defaultParams).toString();
            const response = await apiService.getRequest(`/jobseeker/saved-jobs?${queryString}`);
            if (response && response.success === true) {
                setJobs(response.data);
                setPaginateData2(response.meta);
                setPagesummary2(response.pagination_summary);
            }else{
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error('Error fetching tab data:', error);
        } finally {
            setLoading2(false);
        }
    }, [shorting2, innerSearch2, currentPage2]);

    const handlePageChange2 = (newPage) => {
        setCurrentPage2(newPage);
    };
    const handleSearch2 = () => {
        setCurrentPage2(1);
        setInnersearch2(searchQuery2);
    };

    useEffect(() => {
        fetchSavedJobs();
    }, [fetchSavedJobs]);
    
    const handleApply = async (applyid) => {
        setApplyId(applyid);
        setSubmitloader(true);
        try {
            const params = ({
                job_id : applyid
            })
            const response = await apiService.postRequest('/jobseeker/apply',params);
            if(response && response.success === true){
                setJobs((prevJobs) => prevJobs.map((job) => job.id === applyid ? { ...job, is_applied: true } : job ) );
                toast(response.message || 'Job apply successfully!');
            }else{
                toast(response.message || 'Failed, try again!');
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (err) {
            toast.error("Failed to apply job");
        }finally{
            setSubmitloader(false);
        }
    };
    const handleSave = async (saveid) => {
        try {
            const params = ({
                job_id : saveid
            })
            const response = await apiService.postRequest('/jobseeker/save',params);
            if(response && response.success === true){
                fetchSavedJobs();
                toast(response.message || 'Job saved successfully!');
            }else{
                toast(response.message || 'Failed, try again!');
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (err) {
            toast.error("Failed to save job");
        }
    };
    const handleRemoveSave = async (saveid) => {
        try {
            const response = await apiService.deleteRequest(`/jobseeker/remove-saved/${saveid}`);
            if(response && response.success === true){
                setJobs((prevJobs) =>
                    prevJobs.filter((job) => job.id !== saveid) // remove the job entirely
                );
                toast(response.message || 'Job Unsaved successfully!');
            }else{
                toast(response.message || 'Failed, try again!');
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (err) {
            toast.error("Failed to Unsave job");
        }
    };
  return (
    <div className='container-fluid px-0'>
        <div className='content_container'>
            <Grid size={{sm:12}} container className="main_jobseeker">
                <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead">
                    <h3>Job Board</h3>
                    <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> <b onClick={()=> navigate("/job-board/job-list")}>Job Board</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> My Submission</span>
                </Grid>
                <Grid size={{xs:12}} container>
                    <Grid size={{xs:12}} container flexDirection="column" justifyContent="center" className="tab_controllers">
                        <Tabs
                            activeKey={activeTab}
                            onSelect={(key) => setActiveTab(key)}
                            defaultActiveKey="applied"
                            id="uncontrolled-tab-example" className="mt-4 drafttabs_tabs"
                        >
                            <Tab eventKey="applied" title="Applied">
                                <Grid size={{ xs: 12 }} container justifyContent="space-between" alignItems="center">
                                    <Grid size={{ sm:5,xs: 12 }} container flexDirection="column">
                                        <div className='d-flex jobseekersearch my-3'>
                                            <div className='col-2'>
                                                <FontAwesomeIcon className='iconcol' icon={faMagnifyingGlass} />
                                            </div>
                                            <div className='col-md-7 col-6'>
                                            <input type='text' placeholder='search'
                                                value={searchQuery}
                                                onChange={(e) => setSearchQuery(e.target.value)}
                                                onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    handleSearch(); // Trigger search on Enter key press
                                                }
                                            }}/>
                                            </div>
                                            <div className='col-md-3 col-4'>
                                                <button onClick={handleSearch}>Search</button>
                                            </div>
                                        </div>
                                    </Grid>
                                    <Grid size={{ sm:4,xs: 12 }} container alignItems="center" className="gap-3" justifyContent="end">
                                        <div className='d-flex my-3 short_byonboard'>
                                            <label>Sort by:</label>
                                            <select className='ms-2' onChange={(e) => {setShorting(e.target.value); setCurrentPage(1);}} value={shorting}>
                                                <option value="">Newest</option>
                                                <option value="oldest">Oldest</option>
                                            </select>
                                        </div>
                                    </Grid>
                                </Grid>
                                {loading ? 
                                    <div className='d-flex justify-content-center w-100 mt-5 pt-5'>
                                        <img style={{ width: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
                                    </div> :<>
                                    <Grid size={{ xs:12 }} container justifyContent="center" className="my-4">
                                    {(appliedJobslist && appliedJobslist.length === 0) ?
                                        <span className='w-100 text-center'>No Data</span> :<>
                                        <span className='w-100 total_jobs'>{pageSummary}</span>
                                        {appliedJobslist && appliedJobslist.map((appliedJobslist,index) =>(
                                        <Grid size={{xs:12}} key={index} container className="main_cardjob mt-3">
                                            <Grid size={{xs:12}} container justifyContent="space-between">
                                                <Grid container className="titleadmin_joblist">
                                                    {appliedJobslist && appliedJobslist.source === "LinkedIn" ? 
                                                        <img src={require("../../assets/sample/linkedin.svg").default} alt='Job Icon'/>:
                                                        appliedJobslist.source === "Monster" ?
                                                        <img src={require("../../assets/sample/monster.svg").default} alt='Job Icon'/>:
                                                        appliedJobslist.source === "Indeed" ?
                                                        <img src={require("../../assets/sample/indeed.svg").default} alt='Job Icon'/>:
                                                        appliedJobslist.source === "Glassdoor" ?
                                                        <img src={require("../../assets/sample/glassdoor.svg").default} alt='Job Icon'/>:
                                                        appliedJobslist.source === "Dice" ?
                                                        <img src={require("../../assets/sample/dice.svg").default} alt='Job Icon'/>:
                                                        appliedJobslist.source === "Techfetch" ?
                                                        <img src={require("../../assets/sample/techfetch.svg").default} alt='Job Icon'/>:
                                                        appliedJobslist.source === "TekP Intelligence" ?
                                                        <img src={require("../../assets/sample/tekp.svg").default} alt='Job Icon'/>:
                                                        <img src={require("../../assets/sample/others.svg").default} alt='Job Icon'/>}
                                                    
                                                    <div className='jobboard_listtitle'>
                                                        {appliedJobslist && appliedJobslist.status === "inactive" ?
                                                            <h5 className='tittle_jobswrap'>{appliedJobslist.title}</h5> :
                                                            <Link className='link_joblist' to={`/job-board/job-details/${appliedJobslist.job_id}?my-jobs`}><h5 className='tittle_jobswrap'>{appliedJobslist.title}</h5></Link>
                                                        }
                                                        <h6 className='mb-0'>{appliedJobslist && appliedJobslist.location && appliedJobslist.location !== "" && appliedJobslist.location !== "unknown" && appliedJobslist.location}{appliedJobslist && appliedJobslist.location && appliedJobslist.location !== "" && appliedJobslist.location !== "unknown" && appliedJobslist.recruiter_company && appliedJobslist.recruiter_company !== "" && appliedJobslist.recruiter_company !== "unknown" && ' -'} {appliedJobslist && appliedJobslist.recruiter_company && appliedJobslist.recruiter_company !== "" && appliedJobslist.recruiter_company !== "unknown" && appliedJobslist.recruiter_company }</h6>
                                                    </div>
                                                </Grid>
                                                <Grid container alignItems="center" justifyContent="flex-end" className="endcardjobboard">
                                                    {appliedJobslist && appliedJobslist.recruiter_email && appliedJobslist.recruiter_email[0] !== "" && appliedJobslist.recruiter_email[0] !== "unknown" &&
                                                        <span className="hover_showes">
                                                            <FontAwesomeIcon icon={faEnvelope} />
                                                            <span>
                                                            {appliedJobslist.recruiter_email[0]}
                                                            {appliedJobslist.recruiter_email.length > 1 && " ..."}
                                                            <button
                                                                onClick={() => {
                                                                const copyText = appliedJobslist.recruiter_email.join(", ");
                                                                navigator.clipboard.writeText(copyText);
                                                                toast("Mail ID(s) copied to clipboard");
                                                                }}
                                                            >
                                                                <FontAwesomeIcon icon={faCopy} />
                                                            </button>
                                                            </span>
                                                        </span>
                                                    }
                                                    {appliedJobslist && appliedJobslist.recruiter_phone && appliedJobslist.recruiter_phone !== "" && appliedJobslist.recruiter_phone !== "unknown" &&
                                                        <span className='hover_showes'><FontAwesomeIcon icon={faPhone} />
                                                            <span>{appliedJobslist.recruiter_phone} <button onClick={() => {navigator.clipboard.writeText(`${appliedJobslist.recruiter_phone}`); toast('Phone Number copied to clipboard'); }}><FontAwesomeIcon icon={faCopy} /></button></span>
                                                        </span>
                                                    }
                                                </Grid>
                                            </Grid>
                                            <Grid size={{sm:12,xs:12}} container className="spans_icons column-gap-5 mt-4">
                                                {appliedJobslist && appliedJobslist.site_type && appliedJobslist.site_type !== "" && appliedJobslist.site_type !== "unknown" &&
                                                <Grid container alignItems="center">
                                                    <span className='d-flex align-items-center'><img src={require("../../assets/jobicons/onsite.svg").default} alt='onsite'/>
                                                        <span className='role_typejobicon'>
                                                            <small>Site Type</small>
                                                            <span>{appliedJobslist.site_type}</span>
                                                        </span>
                                                    </span>
                                                </Grid>}
                                                {appliedJobslist && appliedJobslist.experience_range && appliedJobslist.experience_range !== "" && appliedJobslist.experience_range !== "unknown" && appliedJobslist.experience_range !== "Unknown" &&
                                                <Grid container alignItems="center">
                                                    <span className='d-flex align-items-center'><img src={require("../../assets/jobicons/briefcase.svg").default} alt='briefcase'/>
                                                        <span className='role_typejobicon'>
                                                            <small>Experience</small>
                                                            <span>{appliedJobslist.experience_range}</span>
                                                        </span>
                                                    </span>
                                                </Grid>}
                                                {appliedJobslist && appliedJobslist.job_type && appliedJobslist.job_type !== "" && appliedJobslist.job_type !== "unknown" &&
                                                <Grid container alignItems="center">
                                                    <span className='d-flex align-items-center'><img src={require("../../assets/jobicons/jobtype.svg").default} alt='jobtype'/>
                                                        <span className='role_typejobicon'>
                                                            <small>Type</small>
                                                            <span>{appliedJobslist.job_type || "No data"}</span>
                                                        </span>
                                                    </span>
                                                </Grid>}
                                                {appliedJobslist && appliedJobslist.certifications && appliedJobslist.certifications !== "" && appliedJobslist.certifications !== "unknown" &&
                                                <Grid container alignItems="center">
                                                    <span className='d-flex align-items-center'><img src={require("../../assets/jobicons/certificate.svg").default} alt='certificate'/>
                                                        <span className='role_typejobicon'>
                                                            <small>Certifications</small>
                                                            <span>{appliedJobslist.certifications || "No data"}</span>
                                                        </span>
                                                    </span>
                                                </Grid>}
                                                {appliedJobslist && (appliedJobslist.citizenship_status !== null || appliedJobslist.restricted_citizenship_status !== null) &&  <>
                                                {appliedJobslist && (appliedJobslist.citizenship_status !== "unknown" || appliedJobslist.restricted_citizenship_status !== "unknown") &&
                                                <Grid container alignItems="center">
                                                    <span className='d-flex align-items-center'><img src={require("../../assets/jobicons/visa.svg").default} alt='certificate'/>
                                                        <span className='role_typejobicon'>
                                                            <small>Visa</small>
                                                            <div className='d-flex gap-4'>
                                                                <span><FontAwesomeIcon className='iconpinkssets' icon={faCheck} />{appliedJobslist.citizenship_status === "unknown" ? "-" :<> {appliedJobslist.citizenship_status || "-"}</>}</span>
                                                                <span><FontAwesomeIcon className='iconpinkssets' icon={faXmark} /> {appliedJobslist.restricted_citizenship_status === "unknown" ? "-" :<> {appliedJobslist.restricted_citizenship_status || "-"}</>}</span>
                                                            </div>
                                                        </span>
                                                    </span>
                                                </Grid>}
                                                </>}
                                            </Grid>
                                            <Grid size={{xs:12}} container alignItems="flex-end" justifyContent="space-between" className="spans_tagsjob mb-3 gap-3">
                                                <small><span className='job_idshowbox'>Applied On : </span>{appliedJobslist.applied_at} <span className='job_idshowbox ms-3'>Job Id : <span>{appliedJobslist.job_id}</span></span><span className='job_idshowbox ms-3'>Applicants : <span>{appliedJobslist?.job_post_application_count}</span></span><span className='job_idshowbox ms-3'>Applicants Seen : <span>{appliedJobslist.job_post_view_count}</span></span></small>
                                                <Grid container className="gap-3" alignItems="center">
                                                    {appliedJobslist && appliedJobslist.status === "inactive"?
                                                        <button className='disabled_btnview my-0'>View</button>:
                                                        <button className='registersendbtn2 my-0' onClick={()=> navigate(`/job-board/job-details/${appliedJobslist.job_id}?my-jobs`)}>View</button>}
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        ))}
                                    </>}
                                    </Grid>
                                    <Grid size={{xs:12}} container justifyContent="center" className="mt-4 pagination_btn">
                                        <button className='arrowpaginate'
                                            onClick={() => handlePageChange(currentPage - 1)} 
                                            disabled={currentPage === 1}>
                                            <FontAwesomeIcon icon={faChevronLeft} />
                                        </button>
                                        {paginatedata && (
                                            <div className="pagination">
                                                {(() => {
                                                const totalPages = paginatedata.last_page > 0 ? paginatedata.last_page : 1;
                                                const pages = [];
                                                const start = Math.max(2, currentPage - 2);
                                                const end = Math.min(totalPages - 1, currentPage + 2);

                                                // Always show first page
                                                pages.push(
                                                    <button
                                                    key={1}
                                                    onClick={() => handlePageChange(1)}
                                                    className={currentPage === 1 ? 'active' : ''}
                                                    >
                                                    1
                                                    </button>
                                                );

                                                if (start > 2) {
                                                    pages.push(<span key="start-ellipsis">...</span>);
                                                }

                                                for (let i = start; i <= end; i++) {
                                                    pages.push(
                                                    <button
                                                        key={i}
                                                        onClick={() => handlePageChange(i)}
                                                        className={currentPage === i ? 'active' : ''}
                                                    >
                                                        {i}
                                                    </button>
                                                    );
                                                }

                                                if (end < totalPages - 1) {
                                                    pages.push(<span key="end-ellipsis">...</span>);
                                                }

                                                if (totalPages > 1) {
                                                    pages.push(
                                                    <button
                                                        key={totalPages}
                                                        onClick={() => handlePageChange(totalPages)}
                                                        className={currentPage === totalPages ? 'active' : ''}
                                                    >
                                                        {totalPages}
                                                    </button>
                                                    );
                                                }

                                                return pages;
                                                })()}
                                            </div>
                                            )}

                                        <button className='arrowpaginate'
                                            onClick={() => handlePageChange(currentPage + 1)} 
                                            disabled={currentPage === paginatedata.last_page}>
                                            <FontAwesomeIcon icon={faChevronRight} />
                                        </button>
                                    </Grid>
                                </>}
                            </Tab>
                            <Tab eventKey="saved" title="Saved">
                                <Grid size={{ xs: 12 }} container justifyContent="space-between" alignItems="center">
                                    <Grid size={{ sm:5,xs: 12 }} container flexDirection="column">
                                        <div className='d-flex jobseekersearch my-3'>
                                            <div className='col-2'>
                                                <FontAwesomeIcon className='iconcol' icon={faMagnifyingGlass} />
                                            </div>
                                            <div className='col-md-7 col-6'>
                                            <input type='text' placeholder='search'
                                                value={searchQuery2}
                                                onChange={(e) => setSearchQuery2(e.target.value)}
                                                onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    handleSearch2(); // Trigger search on Enter key press
                                                }
                                            }}/>
                                            </div>
                                            <div className='col-md-3 col-4'>
                                                <button onClick={handleSearch2}>Search</button>
                                            </div>
                                        </div>
                                    </Grid>
                                    <Grid size={{ sm:4,xs: 12 }} container alignItems="center" className="gap-3" justifyContent="end">
                                        <div className='d-flex my-3 short_byonboard'>
                                            <label>Sort by:</label>
                                            <select className='ms-2' onChange={(e) => {setShorting2(e.target.value); setCurrentPage2(1);}} value={shorting2}>
                                                <option value="">Newest</option>
                                                <option value="oldest">Oldest</option>
                                            </select>
                                        </div>
                                    </Grid>
                                </Grid>
                                {loading2 ? 
                                    <div className='d-flex justify-content-center w-100 mt-5 pt-5'>
                                        <img style={{ width: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
                                    </div> :<>
                                    <Grid size={{ xs:12 }} container justifyContent="center" className="my-4">
                                    {(Jobslist && Jobslist.length === 0) ?
                                        <span className='w-100 text-center'>No Data</span> :<>
                                    <span className='w-100 total_jobs'>{pageSummary2}</span>
                                    {Jobslist && Jobslist.map((Jobslist,index) =>(
                                        <Grid size={{xs:12}} key={index} container className="main_cardjob mt-3">
                                            <Grid size={{xs:12}} container justifyContent="space-between">
                                                <Grid container className="titleadmin_joblist">
                                                    {Jobslist && Jobslist.source === "LinkedIn" ? 
                                                        <img src={require("../../assets/sample/linkedin.svg").default} alt='Job Icon'/>:
                                                        Jobslist.source === "Monster" ?
                                                        <img src={require("../../assets/sample/monster.svg").default} alt='Job Icon'/>:
                                                        Jobslist.source === "Indeed" ?
                                                        <img src={require("../../assets/sample/indeed.svg").default} alt='Job Icon'/>:
                                                        Jobslist.source === "Glassdoor" ?
                                                        <img src={require("../../assets/sample/glassdoor.svg").default} alt='Job Icon'/>:
                                                        Jobslist.source === "Dice" ?
                                                        <img src={require("../../assets/sample/dice.svg").default} alt='Job Icon'/>:
                                                        Jobslist.source === "Techfetch" ?
                                                        <img src={require("../../assets/sample/techfetch.svg").default} alt='Job Icon'/>:
                                                        Jobslist.source === "TekP Intelligence" ?
                                                        <img src={require("../../assets/sample/tekp.svg").default} alt='Job Icon'/>:
                                                        <img src={require("../../assets/sample/others.svg").default} alt='Job Icon'/>}
                                                    
                                                    <div className='jobboard_listtitle'>
                                                        {Jobslist && Jobslist.status === "inactive" ?
                                                        <h5 className='tittle_jobswrap'>{Jobslist.title}</h5>:
                                                        <Link className='link_joblist' to={`/job-board/job-details/${Jobslist.job_id}?my-jobs`}><h5 className='tittle_jobswrap'>{Jobslist.title}</h5></Link>}
                                                        <h6 className='mb-0'>{Jobslist && Jobslist.location && Jobslist.location !== "" && Jobslist.location !== "unknown" && Jobslist.location}{Jobslist && Jobslist.location && Jobslist.location !== "" && Jobslist.location !== "unknown" && Jobslist.recruiter_company && Jobslist.recruiter_company !== "" && Jobslist.recruiter_company !== "unknown" && ' -'} {Jobslist && Jobslist.recruiter_company && Jobslist.recruiter_company !== "" && Jobslist.recruiter_company !== "unknown" && Jobslist.recruiter_company }</h6>
                                                    </div>
                                                </Grid>
                                                <Grid container alignItems="center" justifyContent="flex-end" className="endcardjobboard">
                                                    {Jobslist && Jobslist.recruiter_email && Jobslist.recruiter_email[0] !== "" && Jobslist.recruiter_email[0] !== "unknown" &&
                                                        <span className="hover_showes">
                                                            <FontAwesomeIcon icon={faEnvelope} />
                                                            <span>
                                                            {Jobslist.recruiter_email[0]}
                                                            {Jobslist.recruiter_email.length > 1 && " ..."}
                                                            <button
                                                                onClick={() => {
                                                                const copyText = Jobslist.recruiter_email.join(", ");
                                                                navigator.clipboard.writeText(copyText);
                                                                toast("Mail ID(s) copied to clipboard");
                                                                }}
                                                            >
                                                                <FontAwesomeIcon icon={faCopy} />
                                                            </button>
                                                            </span>
                                                        </span>
                                                    }
                                                    {Jobslist && Jobslist.recruiter_phone && Jobslist.recruiter_phone !== "" && Jobslist.recruiter_phone !== "unknown" &&
                                                        <span className='hover_showes'><FontAwesomeIcon icon={faPhone} />
                                                            <span>{Jobslist.recruiter_phone} <button onClick={() => {navigator.clipboard.writeText(`${Jobslist.recruiter_phone}`); toast('Phone Number copied to clipboard'); }}><FontAwesomeIcon icon={faCopy} /></button></span>
                                                        </span>
                                                    }
                                                    <small className='d-flex align-items-center'>
                                                        {Jobslist && Jobslist.is_saved === true ?
                                                        <span className='save_jobsspan me-2' onClick={() => handleRemoveSave(Jobslist.id)}>
                                                            <img src={require("../../assets/sample/save_tagpink.svg").default} alt="save"/>
                                                        </span> :
                                                        <span className='save_jobsspan me-2' onClick={() => handleSave(Jobslist.id)}>
                                                            <img src={require("../../assets/sample/save_tagblack.svg").default} alt="save"/>
                                                        </span>}
                                                    </small>
                                                </Grid>
                                            </Grid>
                                            <Grid size={{sm:12,xs:12}} container className="spans_icons column-gap-5 mt-4">
                                                {Jobslist && Jobslist.site_type && Jobslist.site_type !== "" && Jobslist.site_type !== "unknown" &&
                                                <Grid container alignItems="center">
                                                    <span className='d-flex align-items-center'><img src={require("../../assets/jobicons/onsite.svg").default} alt='onsite'/>
                                                        <span className='role_typejobicon'>
                                                            <small>Site Type</small>
                                                            <span>{Jobslist.site_type}</span>
                                                        </span>
                                                    </span>
                                                </Grid>}
                                                {Jobslist && Jobslist.experience_range && Jobslist.experience_range !== "" && Jobslist.experience_range !== "unknown" && Jobslist.experience_range !== "Unknown" &&
                                                <Grid container alignItems="center">
                                                    <span className='d-flex align-items-center'><img src={require("../../assets/jobicons/briefcase.svg").default} alt='briefcase'/>
                                                        <span className='role_typejobicon'>
                                                            <small>Experience</small>
                                                            <span>{Jobslist.experience_range}</span>
                                                        </span>
                                                    </span>
                                                </Grid>}
                                                {Jobslist && Jobslist.job_type && Jobslist.job_type !== "" && Jobslist.job_type !== "unknown" &&
                                                <Grid container alignItems="center">
                                                    <span className='d-flex align-items-center'><img src={require("../../assets/jobicons/jobtype.svg").default} alt='jobtype'/>
                                                        <span className='role_typejobicon'>
                                                            <small>Type</small>
                                                            <span>{Jobslist.job_type || "No data"}</span>
                                                        </span>
                                                    </span>
                                                </Grid>}
                                                {Jobslist && Jobslist.certifications && Jobslist.certifications !== "" && Jobslist.certifications !== "unknown" &&
                                                <Grid container alignItems="center">
                                                    <span className='d-flex align-items-center'><img src={require("../../assets/jobicons/certificate.svg").default} alt='certificate'/>
                                                        <span className='role_typejobicon'>
                                                            <small>Certifications</small>
                                                            <span>{Jobslist.certifications || "No data"}</span>
                                                        </span>
                                                    </span>
                                                </Grid>}
                                                {Jobslist && (Jobslist.citizenship_status !== null || Jobslist.restricted_citizenship_status !== null) &&  <>
                                                {Jobslist && (Jobslist.citizenship_status !== "unknown" || Jobslist.restricted_citizenship_status !== "unknown") &&
                                                <Grid container alignItems="center">
                                                    <span className='d-flex align-items-center'><img src={require("../../assets/jobicons/visa.svg").default} alt='certificate'/>
                                                        <span className='role_typejobicon'>
                                                            <small>Visa</small>
                                                            <div className='d-flex gap-4'>
                                                                <span><FontAwesomeIcon className='iconpinkssets' icon={faCheck} />{Jobslist.citizenship_status === "unknown" ? "-" :<> {Jobslist.citizenship_status || "-"}</>}</span>
                                                                <span><FontAwesomeIcon className='iconpinkssets' icon={faXmark} /> {Jobslist.restricted_citizenship_status === "unknown" ? "-" :<> {Jobslist.restricted_citizenship_status || "-"}</>}</span>
                                                            </div>
                                                        </span>
                                                    </span>
                                                </Grid>}
                                                </>}
                                            </Grid>
                                            <Grid size={{xs:12}} container alignItems="flex-end" justifyContent="space-between" className="spans_tagsjob mb-3 gap-3">
                                                <small>{Jobslist.created_at} <span className='job_idshowbox ms-3'>Job Id : <span>{Jobslist.job_id}</span></span><span className='job_idshowbox ms-3'>Applicants : <span>{Jobslist?.job_post_application_count}</span></span><span className='job_idshowbox ms-3'>Applicants Seen : <span>{Jobslist.job_post_view_count}</span></span></small>
                                                <Grid container className="gap-3">
                                                    {Jobslist && Jobslist.status === "inactive"?
                                                        <button className='disabled_btnview my-0'>View</button>:
                                                        <button className='registersendbtn1 my-0' onClick={()=> navigate(`/job-board/job-details/${Jobslist.job_id}?my-jobs`)}>View</button>}
                                                    {Jobslist && Jobslist.is_applied === true ?
                                                        <button className='disabled_btnapply my-0'>Applied</button>:<>
                                                        {Jobslist && Jobslist.apply_url && Jobslist.apply_url !== "" && Jobslist.apply_url !== null ? 
                                                            <a className='registersendbtn2 my-0 register_flexatags' href={`${Jobslist.apply_url}`} target="_blank" rel="noopener noreferrer">Apply <FontAwesomeIcon icon={faArrowUpRightFromSquare} /></a>
                                                            :
                                                            <button className='registersendbtn2 my-0' onClick={() => handleApply(Jobslist.id)}>{submitloader && Jobslist.id === applyId ? <img src={require('../../assets/whiteloader.gif')} alt=''/> : <>Apply <FontAwesomeIcon icon={faArrowUpRightFromSquare} /></>}</button>
                                                        }</>
                                                    }
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    ))}
                                    </>}
                                    </Grid>
                                    <Grid size={{xs:12}} container justifyContent="center" className="mt-4 pagination_btn">
                                        <button className='arrowpaginate'
                                            onClick={() => handlePageChange2(currentPage2 - 1)} 
                                            disabled={currentPage2 === 1}>
                                            <FontAwesomeIcon icon={faChevronLeft} />
                                        </button>
                                        {paginatedata2 && (
                                        <div className="pagination">
                                            {(() => {
                                            const totalPages = paginatedata2.last_page > 0 ? paginatedata2.last_page : 1;
                                            const pages = [];
                                            const start = Math.max(2, currentPage2 - 2);
                                            const end = Math.min(totalPages - 1, currentPage2 + 2);

                                            // Always show first page
                                            pages.push(
                                                <button
                                                key={1}
                                                onClick={() => handlePageChange2(1)}
                                                className={currentPage2 === 1 ? 'active' : ''}
                                                >
                                                1
                                                </button>
                                            );

                                            if (start > 2) {
                                                pages.push(<span key="start-ellipsis">...</span>);
                                            }

                                            for (let i = start; i <= end; i++) {
                                                pages.push(
                                                <button
                                                    key={i}
                                                    onClick={() => handlePageChange2(i)}
                                                    className={currentPage2 === i ? 'active' : ''}
                                                >
                                                    {i}
                                                </button>
                                                );
                                            }

                                            if (end < totalPages - 1) {
                                                pages.push(<span key="end-ellipsis">...</span>);
                                            }

                                            if (totalPages > 1) {
                                                pages.push(
                                                <button
                                                    key={totalPages}
                                                    onClick={() => handlePageChange2(totalPages)}
                                                    className={currentPage2 === totalPages ? 'active' : ''}
                                                >
                                                    {totalPages}
                                                </button>
                                                );
                                            }

                                            return pages;
                                            })()}
                                        </div>
                                        )}

                                        <button className='arrowpaginate'
                                            onClick={() => handlePageChange2(currentPage2 + 1)} 
                                            disabled={currentPage2 === paginatedata2.last_page}>
                                            <FontAwesomeIcon icon={faChevronRight} />
                                        </button>
                                    </Grid>
                                </>}
                            </Tab>
                        </Tabs>
                    </Grid>
                </Grid>
            </Grid>
        </div>  
    </div>
  )
}

export default MyJobs
